import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  ModalExportList,
} from "App/Component/ui";
import { BASE_URL_4, TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  getByFilterTransferFAExport,
  RESET_STATE_FORM_FILTER,
  urlGetGudang,
} from "./helpers";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "lodash";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
export default function FormFilter({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
  disabledStatus = false,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterTransferFAExport(formFilter);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const gudangUtama = useSelectOption(
    true,
    urlGetGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name"
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={4}>
            <InputTextMaster
              name='id'
              label='ID TRANSFER'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='Id Transfer'
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name='gudang_sumber_id'
              label='GUDANG SUMBER'
              id='gudang_sumber_id'
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_sumber_id}
              labelValue={formFilter.gudang_sumber}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    gudang_sumber_id: null,
                    gudang_sumber: "Pilih Gudang Sumber",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    gudang_sumber_id: e?.value,
                    gudang_sumber: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name='gudang_tujuan_id'
              label='GUDANG TUJUAN'
              id='gudang_tujuan_id'
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_tujuan_id}
              labelValue={formFilter.gudang_tujuan}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    gudang_tujuan_id: null,
                    gudang_tujuan: "Pilih Gudang Tujuan",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    gudang_tujuan_id: e?.value,
                    gudang_tujuan: e?.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name='penerima'
              label='PENERIMA'
              id='penerima'
              value={formFilter.penerima}
              onChange={handleChange("penerima")}
              placeholder='Penerima'
            />
          </Grid>
          <Grid item sm={4}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AWAL
            </label>

            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tglAwal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
          <Grid item sm={4}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AKHIR
            </label>

            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tglAkhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <div style={{ display: "flex", gap: 16 }}>
            <MasterButton
              type={"button"}
              color='primary-cyan'
              name={"Export List"}
              size='md'
              onClick={() => setShowModalExportList(!showModalExportList)}
            />

            <MasterButton
              type={"button"}
              color='warning'
              name={isLoading ? "Loading..." : "EXPORT"}
              disabled={isLoading}
              size='md'
              onClick={handleExport}
            />
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              onClick={handleSubmit}
              type={typeButton}
              size={"md"}
            />
          </div>
        </Grid>
      </form>
      {showModalExportList && (
        <ModalExportList
          title={"Export Transfer Fixed Asset"}
          showModal={() => setShowModalExportList(false)}
          type='TransferAsset'
          service={BASE_URL_4}
        />
      )}
    </>
  );
}
